import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function ViewBairro() {
  const [data, setData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const carregarDados = () => {
    axios.get('/api/projetosbairros')
      .then(res => {
        if (res.data.Status === "Success") {
          setData(res.data.Result);
        } else {
          alert("Erro ao carregar dados");
        }
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    const userRole = localStorage.getItem('UserRole');
    setIsAdmin(userRole === 'admin');
    carregarDados();
  }, []);

  const handleDelete = (id) => {
    if (window.confirm("Tem certeza que deseja deletar este lançamento?")) {
      axios.delete(`/api/projetosbairros/${id}`)
        .then(res => {
          if (res.data.message === "Orçamento deletado com sucesso!") {
            alert('Lançamento deletado!');
            carregarDados();
          } else {
            alert('Erro ao deletar o lançamento');
          }
        })
        .catch(err => {
          console.error(err);
          alert('Erro no servidor');
        });
    }
  };

  return (
    <div className="fs-11 px-18 py-8" style={{ overflow: 'visible' }}>
      <div className="d-flex justify-content-center mb-3">
        <h3>Lista de Lançamentos Orçamentários</h3>
      </div>

      <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
        {isAdmin && (
          <Link to="/addprojetobairro" className="btn btn-success">
            + Novo Lançamento
          </Link>
        )}
        <Link to="/" className="btn btn-secondary">
          Voltar
        </Link>

        <input
          type="text"
          placeholder="Buscar por Bairro, Zona, Tipo..."
          className="form-control"
          style={{ maxWidth: '300px' }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table className="table table-responsive table-bordered table-hover">
          <thead className="table-danger">
            <tr>
              <th>Bairro</th>
              <th>Zona</th>
              <th>Descrição</th>
              <th>Programa</th>
              <th>Tipo</th>
              <th>Valor (R$)</th>
              {isAdmin && <th>Ações</th>}
            </tr>
          </thead>
          <tbody>
            {data
              .filter((tabela_bairros) => {
                const search = searchTerm.toLowerCase();
                return (
                  tabela_bairros.Bairro?.toLowerCase().includes(search) ||
                  tabela_bairros.Zona?.toLowerCase().includes(search) ||
                  tabela_bairros.Descricao?.toLowerCase().includes(search) ||
                  tabela_bairros.Tipo?.toLowerCase().includes(search) ||
                  tabela_bairros.Valor?.toString().toLowerCase().includes(search) ||
                  tabela_bairros.Programarograma?.toString().includes(search)
                );
              })
              .map((tabela_bairros, index) => (
                <tr key={index}>
                  <td>{tabela_bairros.Bairro}</td>
                  <td>{tabela_bairros.Zona}</td>
                  <td>{tabela_bairros.Descricao}</td>
                  <td>{tabela_bairros.programa}</td>
                  <td>{tabela_bairros.Tipo}</td>
                  <td>
                    {(() => {
                      const valor = tabela_bairros.Valor;
                      if (valor === null || valor === undefined) return '';
                      const valorNum = Number(valor);
                      if (isNaN(valorNum)) return 'Valor inválido';
                      return valorNum.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                    })()}
                  </td>
                  {isAdmin && (
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(tabela_bairros.ID)}
                      >
                        Deletar
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewBairro;
